/**
 * Money helpers — all monetary values are stored/transmitted as integer
 * cents (BRL). Conversion between "reais as typed by the user" and cents
 * must never rely on raw float multiplication.
 */

const stripFormatting = (raw: string): string => {
    let value = raw.trim().replace(/\s|R\$/g, '')
    // pt-BR inputs like "1.234,56": dots are thousand separators.
    if (value.includes(',')) {
        value = value.replace(/\./g, '').replace(',', '.')
    }
    return value
}

export const realToCents = (
    input: string | number | null | undefined
): number => {
    if (input === null || input === undefined || input === '') return 0
    const raw = stripFormatting(String(input))
    if (!/^-?\d*\.?\d+$/.test(raw)) return 0

    const negative = raw.startsWith('-')
    const unsigned = raw.replace('-', '')
    const [intPart = '', fracPart = ''] = unsigned.split('.')
    const intCents = Number(intPart || '0') * 100
    const fracCents = Number((fracPart + '00').slice(0, 2) || '0')
    const cents = intCents + fracCents
    return negative ? -cents : cents
}

export const formatBRL = (cents?: number | null): string => {
    if (cents === null || cents === undefined || Number.isNaN(cents)) {
        return '-'
    }
    return (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
}

export const formatLeadTime = (days?: number | null): string => {
    if (days === null || days === undefined) return '-'
    return `${days} ${days === 1 ? 'dia' : 'dias'}`
}

/** Centavos → texto editável pt-BR sem símbolo ("1.234,56"); 0/vazio → "". */
export const centsToInput = (cents?: number | null): string => {
    if (!cents) return ''
    return (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
